export default __webpack_public_path__ + "static/media/stock_token_hive.c33c6c2e.svg";